import parseUrl from 'url-parse';
var pageUrl = parseUrl(window.location.href, true);
$(document).ready(function () {
  var phone = pageUrl.query.utm_source; //  check for affiliate source that needs phone number added

  if (phone === '1800ian') {
    $('#utmphone').show();
  }
});